<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ edit ? $t('events.planning.notes.note_modification') : $t('events.planning.notes.note_creation') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
              :name="`${id}-note_name`"
              type="text"
              :label="$t('events.planning.notes.note_name')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="true" 
              size="lg"
              :placeholder="$t('events.planning.notes.note_name')"
              v-model="formDataNote.title"
            />
            <CKEditor
                container-class="h-300px"
                :id="'events.planning.notes-note'+id"
                :content="formDataNote.content"
                @text="getContent"
            />
          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="cancel" id="submit_btn" btn-text="button.cancel" size="7px 30px" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import {ref} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";
  import CKEditor from '@/components/CKEditor.vue';
  import { useRoute } from "vue-router";
  
  const emits = defineEmits(['load'])

  const props = defineProps({
      id: {
        type: String,
        required: true
      },
      atelier: {
        type: String,
        required: true
      },
      parent: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        default: {
          id: '',
          title: '',
          content: '',
        }
      },
      edit: {
        type: Boolean,
        default: false
      }
  })

  const store = useStore()
  const route = useRoute()

  const formDataNote = ref(props.form)
  const loading = ref(false)

  async function submitForm(){
    let action = props.edit ? 'notes/updateNote' : 'notes/createNote';
    let message = props.edit ? 'notifications.note_updated_successfully' : 'notifications.note_created_successfully';
    try {
      loading.value = true;
      await store.dispatch(action, {...formDataNote.value, atelier_id: props.atelier }).then((res) =>{
        emits('load');
        formDataNote.value.id = ''
        formDataNote.value.title = ''
        formDataNote.value.content = ''
        closeModal();
        window.toastr['success'](i18n.global.t(message))
      }) 
    } catch (error) {
    } finally {
      loading.value = false;
    }
  }

  function getContent(text) {
    formDataNote.value.content = text
  }

  function closeModal(){
    if(props.parent){
        $('#'+props.parent).modal('toggle')
    }
    $('#'+props.id).modal('toggle')
  }
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>